<template>
  <div>
    <v-row class="mb-3">
      <v-col cols="12" sm="3" v-if="cotacao.cpfCnpjColeta">
        <span class="caption font-weight-bold">CPF/CNPJ de coleta</span>
        <div>
          {{ cotacao.cpfCnpjColeta | cpfCnpj }}
        </div>
      </v-col>
      <v-col cols="12" sm="3" v-if="cotacao.cpfCnpjEntrega">
        <span class="caption font-weight-bold">CPF/CNPJ de entrega</span>
        <div>
          {{ cotacao.cpfCnpjEntrega | cpfCnpj }}
        </div>
      </v-col>
      <v-col cols="12" sm="3" v-if="cotacao.localPagamento">
        <span class="caption font-weight-bold">Pagador</span>
        <div>
          {{ localPagamento }}
        </div>
      </v-col>
    </v-row>
    <v-row class="mb-3">
      <v-col cols="12" sm="6">
        <span class="caption font-weight-bold">Coleta</span>
        <div>
          {{ cotacao.cepColeta | cep }}
          ({{ cotacao.municipioColeta.nome }} - {{ cotacao.municipioColeta.estado.sigla }})
        </div>
      </v-col>
      <v-col cols="12" sm="6">
        <span class="caption font-weight-bold">Entrega</span>
        <div>
          {{ cotacao.cepEntrega | cep }}
          ({{ cotacao.municipioEntrega.nome }} - {{ cotacao.municipioEntrega.estado.sigla }})
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="3">
        <span class="caption font-weight-bold">Peso total (kg)</span>
        <div>
          {{ cotacao.pesoTotal }} kg
        </div>
      </v-col>
      <v-col cols="12" sm="3">
        <span class="caption font-weight-bold">Valor da mercadoria</span>
        <div>
          {{ cotacao.valorMercadoria | currency }}
        </div>
      </v-col>
      <v-col cols="12" sm="3">
        <span class="caption font-weight-bold">Quantidade de notas fiscais</span>
        <div>
          {{ cotacao.quantidadeNotas }}
        </div>
      </v-col>
      <v-col cols="12" sm="3">
        <span class="caption font-weight-bold">Tipo de mercadoria</span>
        <div>
          {{ cotacao.tipoMercadoria }}
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <span class="caption font-weight-bold">Observação</span>
        <div>
          {{ cotacao.observacao | naoInformado }}
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6">
        <v-card outlined>
          <v-subheader>
            <v-icon class="mr-2">mdi-package-variant</v-icon>
            Volumes
          </v-subheader>
          <v-divider/>
          <div class="body-1 mt-3" align="center"
               v-if="!cotacao.volumes || !cotacao.volumes.length">
            Não há volumes nessa cotação
          </div>
          <px-cotacao-frete-volumes :cotacao="cotacao"/>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6">
        <v-card outlined>
          <v-subheader>
            <v-icon class="mr-2">mdi-truck</v-icon>
            Transportadoras
            <template v-if="isAberta">
              <v-spacer></v-spacer>
              <px-cotacao-frete-adicionar-transportador :cotacao="cotacao" @update="emitUpdate">
                <template v-slot:activator="{ on }">
                  <v-btn x-small class="ml-2" color="primary" v-on="on">
                    <v-icon x-small>mdi-plus</v-icon>
                    Transportador
                  </v-btn>
                </template>
              </px-cotacao-frete-adicionar-transportador>
            </template>
          </v-subheader>
          <v-divider/>
          <px-cotacao-frete-transportadoras :cotacao="cotacao"
                                            :solicitacoes="solicitacoes"/>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { SituacaoCotacao, LocalPagamentoFrete } from 'px-business-components';
import CotacaoFreteVolumes from './CotacaoFreteVolumes.vue';
import CotacaoFreteTransportadoras from './CotacaoFreteTransportadoras.vue';
import CotacaoFreteAdicionarTransportador from '../CotacaoFreteAdicionarTransportador.vue';

export default {
  props: {
    solicitacoes: Array,
    cotacao: Object,
  },
  computed: {
    isAberta() {
      return SituacaoCotacao.keys.ABERTA.key === this.cotacao.situacao;
    },
    localPagamento() {
      return LocalPagamentoFrete.keys[this.cotacao.localPagamento].description;
    },
  },
  methods: {
    emitUpdate() {
      this.$emit('update');
    },
  },
  components: {
    pxCotacaoFreteVolumes: CotacaoFreteVolumes,
    pxCotacaoFreteTransportadoras: CotacaoFreteTransportadoras,
    pxCotacaoFreteAdicionarTransportador: CotacaoFreteAdicionarTransportador,
  },
};
</script>
